/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterLeagueTeamBody
 */
export interface RegisterLeagueTeamBody {
    /**
     * The team to register for this league
     * @type {string}
     * @memberof RegisterLeagueTeamBody
     */
    teamId: string;
}

/**
 * Check if a given object implements the RegisterLeagueTeamBody interface.
 */
export function instanceOfRegisterLeagueTeamBody(value: object): value is RegisterLeagueTeamBody {
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    return true;
}

export function RegisterLeagueTeamBodyFromJSON(json: any): RegisterLeagueTeamBody {
    return RegisterLeagueTeamBodyFromJSONTyped(json, false);
}

export function RegisterLeagueTeamBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterLeagueTeamBody {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'],
    };
}

export function RegisterLeagueTeamBodyToJSON(json: any): RegisterLeagueTeamBody {
    return RegisterLeagueTeamBodyToJSONTyped(json, false);
}

export function RegisterLeagueTeamBodyToJSONTyped(value?: RegisterLeagueTeamBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
    };
}

